document.addEventListener('DOMContentLoaded', () => {
  const picker = document.querySelector('variant-picker');
  if (!picker) return;

  const skuDisplay = document.getElementById('variant-sku');
  if (!skuDisplay) return;

  const select = document.querySelector('.variant-option__select');
  if (!select) return;

  const variants = window.ShopifyAnalytics?.meta?.product?.variants ?? [];

  const updateSku = () => {
    const variantId = Number(select.options[select.selectedIndex].dataset.variantId);
    const variant = variants.find(v => v.id === variantId);
    skuDisplay.textContent = variant?.sku ?? '';
  };

  select.addEventListener('change', updateSku);
  updateSku();
});